<template>
  <div class="online-courses-page">
    <div class="heading">
      <h1>
        Unlock the power of blockchain with our expert-led Tutorials at Azadi Coin
        Academy!
      </h1>
    </div>
    <h3>FIND THE RIGHT TUTORIAL FOR YOU</h3>
    <div class="filter-section">
      <label for="filter">Filter by</label>
      <select id="filter" v-model="filterOption">
        <option value="newly-launched">Newly Launched</option>
        <!-- Add more filter options if needed -->
      </select>
    </div>
    <div class="courses-grid">
      <div
        v-for="course in filteredCourses"
        :key="course.id"
        class="course-card"
        @click="handleRoute('/course-detail/'+course.id)"
      >
        <img :src="course.course_image" alt="course image" class="course-image" />
        <div class="course-details">
          <h4>{{ course.name }}</h4>
          <p class="duration">
            {{ course.duration }} minutes <span class="ml-2"> ● {{course.certification}} </span>
          </p>
          <p class="price" v-if="course.payment_option!='free'">{{ course.price }} Azadi Coin (AC)</p>
          <p class="price" v-else>Free</p>
        </div>
        <router-link :to="'/course-detail/'+course.id"
          ><button class="enroll-btn">Enroll Now</button></router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      filterOption: "newly-launched",
      courses: []
    };
  },
  computed: {
    filteredCourses() {
      // Logic to filter courses based on the selected option
      // (Here we return all courses for simplicity)
      return this.courses;
    },
  },
  mounted() {
    this.courseList();
  },
  methods: {
    handleRoute(route) {
      this.$router.push(route)
    },
    async courseList() {
      try {
        const response = await axios.get("courses?category_id="+this.$route.params.id);
        this.courses = response.data.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
.online-courses-page {
  text-align: center;
  font-family: 'GothicB';
}
.heading {
  background-color: #0e1332;
}

h3 {
  max-width: 65rem;
  margin: 0 auto 2rem;
  text-align: left;
  padding: 0 1.5rem;
  color: #fff;
}
.online-courses-page h1 {
  padding: 3rem 1.5rem;
  max-width: 65rem;
  margin: 0 auto 2rem;
  color: #fff;
  text-align: left;
  line-height: 4rem;
}

.filter-section {
  text-align: left;
  margin: 2rem 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 65rem;
  padding: 0 1.5rem;
  margin: 0 auto 2rem;
}

.filter-section label {
  margin-right: 1rem;
  font-weight: 700;
  color: #fff;
}

.filter-section select {
  padding: 0.5rem;
  background-color: transparent;
  border: 1px solid #f0c57a;
  color: #f0c57a;
  font-family: 'Gothic';
  border-radius: 5px;
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  max-width: 60rem;
  margin: 0 auto 5rem;
  padding: 0 1.5rem;
}

.course-card {
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #121E4A;
  text-align: left;
  cursor: pointer;
  color: #fff;
  display: flex;
  flex-direction: column;
}
@media screen and (min-width: 781px){
  .courses-grid .course-card {
    max-width: 18rem;
  }
}

.course-card:hover {
  transform: scale(1.1);
  transition: all .5s;
  cursor: pointer;
}
.course-image {
  width: 100%;
  border-radius: 5px;
  border-bottom: 5px solid #f0c57a;
}

.course-details {
  padding: 0.5rem;
  flex: 1;
}

.course-details h3 {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}

.course-details p {
  margin-top: 0.8rem;
}

.duration {
  font-size: 0.8rem;
  color: rgb(178, 178, 178);
}

.price {
  font-weight: bold;
}

.enroll-btn {
  padding: 0.5rem 1rem;
  border: none;
  width: 100%;
  background-color: #f0c57a;
  color: #000;
  cursor: pointer;
  margin-top: 1rem;
  font-size: 1rem;
}

.ml-2 {
  margin-left: 1rem;
}

.enroll-btn:hover {
  background-color: #aacae7;
}
@media screen and (max-width: 850px) {
  .course-card {
    max-width: initial;
  }
}
</style>
